
export default {
  install(Vue){
    //判断地址的后缀名
    Vue.prototype.mFormat=function (url){
      // var url="www.com.cn/aa.swf?t=1111&d=222";
      var arrT=url.split('/');
      var strT=arrT[arrT.length-1];
      var file="";
      if(strT.indexOf("?")){
        file=strT.split('?')[0];
      }else{
        file=strT;
      }
      var ext="html";
      if(file.indexOf(".") != -1){
        var fileLength=file.split(".");
        ext=fileLength[fileLength.length-1];
      }
      return ext.toLowerCase();
    };
  }
}



// WEBPACK FOOTER //
// ./src/api/commonM.js